import { TRootState } from "../../types"

export const getUsersSelector = (state: TRootState) => state.users
